// extracted by mini-css-extract-plugin
module.exports = {"container":"BoardCommittees_container__3cH-8","note":"BoardCommittees_note__1R5So","bordered":"BoardCommittees_bordered__3OCHQ"};